<div *ngIf="!fold.erlId" class="description">
  <div [ngClass]= "{'grid': fold.sEmailtrt ===1}">
    <div [ngClass]="{'col-12': fold.sEmailtrt === 0 || !fold.sEmailtrt, 'col-6': fold.sEmailtrt === 1}">
      <p-fieldset [toggleable]="false"
                  [legend]="'LABEL.GIVEN.BY.BACK.vwSentsList.sDestinataire.lbl' | translate">
        {{ fold.sDestinataire }}
      </p-fieldset>
    </div>

    <div *ngIf="fold.sEmailtrt === 1" class="col-6">
      <p-fieldset [toggleable]="false"
                  [legend]="'EMAIL.INFO_TITLE' | translate">
        <div class="col-12">
          <div class="col-4">{{ 'EMAIL.SUBJECT' | translate }}</div>
          <div class="col-8">{{ fold.subject }}</div>
          <div class="col-4">{{ 'EMAIL.STATUS' | translate }}</div>
          <div class="col-8">{{ ('EMAIL.STATUS_LIST.' + fold.status) | translate }}</div>
          <div class="col-4">{{ 'EMAIL.RECIPIENT_EMAIL' | translate }}</div>
          <div class="col-8">{{ fold.recipientEmailAddress }}</div>
          <div class="col-4">{{ 'EMAIL.TEMPLATE' | translate }}</div>
          <div class="col-8">{{ getTemplateLabel(fold.template) }}</div>
          <div class="col-4">{{ 'EMAIL.BOUNCE' | translate }}</div>
          <div class="col-8">{{ fold.bounce ? "oui" : "non" }}</div>
          <div class="col-4" *ngIf="fold.bounceSent">{{ 'EMAIL.BOUNCE_SEND' | translate }}</div>
          <div class="col-8" *ngIf="fold.bounceSent">{{
              fold.bounceSent === 1 ? fold.bounceSent + " jour" : fold.bounceSent + " jours" }}</div>
        </div>
      </p-fieldset>
    </div>
    <!--Fold id-->
    <div class="col-4">

      <p-fieldset [toggleable]="false" [legend]="'FOLD.DETAIL_COMPONENT.FOLD_ID_TITLE' | translate">

        <!--Deposit number-->
        <div class="col-12 noHorizontalPadding littleFont">
          <div class="col-4 noPadding">{{ 'FOLD.DETAIL_COMPONENT.FOLD_ID_DEPOSIT_NUMBER' | translate }}:</div>
          <div class="col-8 align-right noPadding" (click)="addDepositAsFilter()">
            <i *ngIf="displayDepositFilter" title="{{ 'FOLD.DETAIL_COMPONENT.HOVER_DEPOSIT_FILTER' | translate }}"
               class="clickable fa fa-filter" aria-hidden="true"></i>
            {{ fold.lSerialLotDepot }}
          </div>
        </div>
        <!--End of Deposit number-->

        <!--Document number-->
        <div class="col-12 noHorizontalPadding littleFont">
          <div class="col-4 noPadding">{{ 'FOLD.DETAIL_COMPONENT.FOLD_ID_DOCUMENT_NUMBER' | translate }}:</div>
          <div class="col-8 align-right noPadding"> {{ fold.lSerialDoc }}</div>
        </div>
        <!--End of Document number-->

        <!--send number-->
        <div class="col-12 noHorizontalPadding littleFont">
          <div class="col-4 noPadding">{{ 'FOLD.DETAIL_COMPONENT.FOLD_ID_SEND_NUMBER' | translate }}:</div>
          <div class="col-8 align-right noPadding" (click)="addSentAsFilter()">
            <i *ngIf="displaySendFilter" title="{{ 'FOLD.DETAIL_COMPONENT.HOVER_SEND_FILTER' | translate }}"
               class="clickable fa fa-filter" aria-hidden="true"></i>
            {{ fold.serialSent }}
          </div>
        </div>
        <!--End of send number-->
      </p-fieldset>

    </div>
    <!--End of Fold id-->

    <!--Chronology-->
    <div class="col-4">

      <p-fieldset [toggleable]="false" [legend]="'FOLD.DETAIL_COMPONENT.FOLD_CHRONOLOGY_TITLE' | translate">

        <!--Deposit date-->
        <div *ngIf="fold.delayedsenddate" class="col-12 noHorizontalPadding littleFont">
          <div class="col-3 noPadding">
            {{ 'FOLD.DETAIL_COMPONENT.FOLD_CHRONOLOGY_DEPOSIT' | translate }}:
          </div>
          <div class="col-3 align-right noPadding">
            {{ shortenDate(fold.sFormatedDepotDateTime) }}
          </div>
          <div class="col-1 noPadding"></div>
          <div class="col-3 noPadding">
            {{ 'FOLD.DETAIL_COMPONENT.FOLD_CHRONOLOGY_PALNNED' | translate }}:
          </div>
          <div class="col-2 align-right noPadding">
            {{ formatTimeStamp(fold.delayedsenddate) }}
          </div>
        </div>
        <div *ngIf="!fold.delayedsenddate" class="col-12 noHorizontalPadding littleFont">
          <div class="col-3 noPadding">
            {{ 'FOLD.DETAIL_COMPONENT.FOLD_CHRONOLOGY_DEPOSIT' | translate }}:
          </div>
          <div class="col-9 align-right noPadding">
            {{ shortenDate(fold.sFormatedDepotDateTime) }}
          </div>
        </div>
        <!--End of Chronology-->


        <!--Printing date-->
        <div class="col-12 noHorizontalPadding littleFont">
          <div class="col-3 noPadding">
            {{ 'FOLD.DETAIL_COMPONENT.FOLD_CHRONOLOGY_PRINT' | translate }}:
          </div>
          <div class="col-9 align-right noPadding">
            {{ shortenDate(fold.sFormatedSentPrintDate) }}
          </div>
        </div>
        <!--End of Printing date-->

        <!--Postage date-->
        <div class="col-12 noHorizontalPadding littleFont">
          <div class="col-6 noPadding">
            {{ 'FOLD.DETAIL_COMPONENT.FOLD_CHRONOLOGY_DELIVERY' | translate }}:
          </div>
          <div class="col-6 align-right noPadding">
            {{ shortenDate(fold.sFormatedSentDepositDate) }}
          </div>
        </div>
        <!--End of Postage date-->

      </p-fieldset>

    </div>
    <!--End of Deposit infos-->

    <!-- Postal info-->
    <div class="col-4">

      <p-fieldset [toggleable]="false" [legend]="'FOLD.DETAIL_COMPONENT.FOLD_POSTAL_TITLE' | translate">

        <div class="col-12 noHorizontalPadding littleFont">
          <div class="col-12 noPadding">
            {{ 'FOLD.DETAIL_COMPONENT.FOLD_POSTAL_STAMP' | translate }}: {{ fold.sPostalTrtPostageEnvois }}
          </div>
          <div *ngIf="fold.sSentRecoID" class="col-12"> {{ 'FOLD.DETAIL_COMPONENT.FOLD_RECO_ID' | translate }}
            : {{ fold.sSentRecoID }}
          </div>
        </div>

        <div *ngIf="fold.sFormatedSentARDate" class="col-12 noHorizontalPadding littleFont">
          <div class="col-6 noPadding">
            {{ 'FOLD.DETAIL_COMPONENT.FOLD_POSTAL_AR_DATE' | translate }}:
          </div>
          <div class="col-6 align-right noPadding">
            {{ fold.sFormatedSentARDate }}
          </div>
        </div>
        <div *ngIf="fold.sFormatedDatepnd" class="col-12 noHorizontalPadding littleFont">
          <div class="col-6 noPadding">
            {{ 'FOLD.DETAIL_COMPONENT.FOLD_POSTAL_PND_DATE' | translate }}:&nbsp;&nbsp;{{ fold.sFormatedDatepnd }}
          </div>
          <div class="col-6 noPadding">
            {{ fold.motifText }}
          </div>
        </div>
        <div class="col-12 " style="padding: 0.2em 0 0.2em 0;">
          <div class="col-6 noHorizontalPadding littleFont">
            <button pButton type="button" [icon]="'fa fa-info-circle'"
                    [label]="'FOLD.DETAIL_COMPONENT.FOLD_DETAIL_TRACKING' | translate"
                    (click)="openPostalTracking(fold.serialSent)"></button>
          </div>
          <div *ngIf="fold.sEmailtrt ===1" class="col-6 noHorizontalPadding littleFont align-right">
            <button pButton type="button" [icon]="'fa fa-info-circle'"
                    [label]="'FOLD.DETAIL_COMPONENT.FOLD_DETAIL_TRACKING_MAIL' | translate"
                    (click)="openEmailTracking(fold.serialSent)"></button>
          </div>
          <div *ngIf="fold.sSentRecoID" class="col-6 noHorizontalPadding littleFont">
            <button pButton type="button" [icon]="'fa fa-external-link'"
                    [label]="'FOLD.DETAIL_COMPONENT.FOLD_PROVIDER_TRACKING' | translate"
                    (click)="openExternalTracking(fold.sSentRecoID)"></button>
          </div>
        </div>
      </p-fieldset>

    </div>
    <!-- End of Postal info-->
  </div>


</div>
<div class="trackingModal" *ngIf="showTracking">
  <p-dialog [(visible)]="showTracking" [header]="'FOLD.DETAIL_COMPONENT.FOLD_PROVIDER_TRACKING_TITLE'|translate"
            [draggable]="false"
            [closable]="true"
            [resizable]="false"
            [modal]="true" [closeOnEscape]="false" (onHide)="closeTracking()">

    <app-suivi-reco [recoId]="fold.sSentRecoID"></app-suivi-reco>
  </p-dialog>
</div>
<div *ngIf="fold.erlId" class="description">
  <div class="grid">
    <div class="col-6">

      <p-fieldset [toggleable]="false" [legend]="'ERL.FIELD_HEADER.SENDER' | translate">
        <div class="col-12">
          <div class="col-3">{{ 'COMMON.USERNAME' | translate }}</div>
          <div class="col-9">{{ fold.senderTitle }} {{ fold.senderLastName }} {{ fold.senderFirstName }}</div>
        </div>
        <div class="col-12">
          <div class="col-3">{{ 'UPLOAD_COMPONENT.LRE_S_COMPANY_LABEL' | translate }}</div>
          <div class="col-9">{{ fold.senderCompany }}</div>
        </div>
        <div class="col-12" *ngIf="fold.senderPhoneNumber">
          <div class="col-3">{{ 'UPLOAD_COMPONENT.LRE_S_PHONE_LABEL' | translate }}</div>
          <div class="col-9">{{ fold.senderPhoneNumber }}</div>
        </div>
        <div class="col-12">
          <div class="col-3">{{ 'UPLOAD_COMPONENT.LRE_S_MAIL_LABEL' | translate }}</div>
          <div class="col-9">{{ fold.senderMailAddress }}</div>
        </div>
        <div class="col-12">
          <div class="col-3">{{ 'UPLOAD_COMPONENT.LRE_S_ADDRESS_LABEL' |translate }}</div>
          <div class="col-9">{{ fold.senderAddress }}</div>
        </div>
      </p-fieldset>
    </div>
    <div class="col-6">
      <p-fieldset [toggleable]="false" [legend]="'ERL.FIELD_HEADER.RECIPIENT' | translate">
        <div class="col-12">
          <div class="col-3">{{ 'COMMON.USERNAME' | translate }}</div>
          <div class="col-9">{{ fold.recipientTitle }} {{ fold.recipientLastName }} {{ fold.recipientFirstName }}</div>
        </div>
        <div class="col-12">
          <div class="col-3">{{ 'UPLOAD_COMPONENT.LRE_S_COMPANY_LABEL' |translate }}</div>
          <div class="col-9">{{ fold.recipientCompany }}</div>
        </div>
        <div class="col-12" *ngIf="fold.recipientPhoneNumber">
          <div class="col-3">{{ 'UPLOAD_COMPONENT.LRE_S_PHONE_LABEL' | translate }}</div>
          <div class="col-9">{{ fold.recipientPhoneNumber }}</div>
        </div>
        <div class="col-12">
          <div class="col-3">{{ 'UPLOAD_COMPONENT.LRE_S_MAIL_LABEL' | translate }}</div>
          <div class="col-9">{{ fold.recipientMailAddress }}</div>
        </div>
        <div class="col-12">
          <div class="col-3">{{ 'UPLOAD_COMPONENT.LRE_S_ADDRESS_LABEL' |translate }}</div>
          <div class="col-9">{{ fold.recipientAddress }}</div>
        </div>
      </p-fieldset>
    </div>
    <div class="col-12">
      <p-fieldset [toggleable]="false" [legend]="'ERL.FIELD_HEADER.PROOFS' | translate">

        <div class="col-4" *ngIf="fold.externalUrl">
          <button pButton type="button" [icon]="'fa fa-external-link'"
                  [label]="'UPLOAD_COMPONENT.LRE_PROOFS_LINK' | translate"
                  (click)="openExternalLink(fold.externalUrl)"></button>
        </div>
        <div class="col-4" *ngIf="!fold.externalUrl">
          {{ 'UPLOAD_COMPONENT.LRE_PROOFS_LINK_UNAVAILABLE' | translate }} !
        </div>
        <div class="col-8" *ngIf="fold.status === 'SEND_PAPER'">
          <div class="col-6 align-right">{{ 'FOLD.DETAIL_COMPONENT.TREATMENT_CHAIN_LABEL' | translate }}
            : {{ fold.trtChainName }}
          </div>
          <div class="col-6 align-right">{{ 'FOLD.DETAIL_COMPONENT.LRE_PAPER_ASSOCIATED_PAPER'|translate }} :
            <i *ngIf="displaySendFilter" title="{{ 'FOLD.DETAIL_COMPONENT.SHOW_LRE_PAPER' | translate }}"
               class="clickable fa fa-filter" aria-hidden="true" (click)="searchWithSerialSent()">
              {{ fold.serialSent }}
            </i></div>
        </div>
      </p-fieldset>
    </div>
  </div>

</div>
<p-dialog *ngIf="openPostalTrackingModal" [(visible)]="openPostalTrackingModal" [styleClass]="'postal-tracking-modal'"
          [appendTo]="'body'"
          [header]="'FOLD.ACTION_COMPONENT.POSTAL_TRACKING_MODAL_TITLE' | translate"
          [draggable]="false"
          [closable]="false"
          [resizable]="false"
          [modal]="true"
          [closeOnEscape]="false">

  <p-header>
    <button pButton type="button" [label]="" style="float:right;margin-left: 2px;" (click)="closePostalTracking()"
            icon="fa fa-close"></button>
  </p-header>

  <app-custom-list [columns]="postalTrackinColumns" [datas]="postalTrackinData" [consultable]="false"
                   [downloadable]="false"
                   [convertibleAsText]="false">
  </app-custom-list>
</p-dialog>
<p-dialog *ngIf="openEmailTrackingModal" [(visible)]="openEmailTrackingModal" [styleClass]="'postal-tracking-modal'"
          [appendTo]="'body'"
          [header]="'FOLD.ACTION_COMPONENT.POSTAL_TRACKING_MODAL_TITLE' | translate"
          [draggable]="false"
          [closable]="false"
          [resizable]="false"
          [modal]="true"
          [closeOnEscape]="false">

  <p-header>
    <button pButton type="button" [label]="" style="float:right;margin-left: 2px;" (click)="closeEmailTracking()"
            icon="fa fa-close"></button>
  </p-header>

  <app-custom-list [columns]="emailTrackinColumns" [datas]="emailTrackinData" [consultable]="false"
                   [downloadable]="false"
                   [convertibleAsText]="false">
  </app-custom-list>
</p-dialog>
